<template>
	<div class="page-content__content page-content__content--noindent">
		<TenderTab ref="tenderTab" v-model="currentTab"/>
		<TenderForm
			:type="currentTab"
			:deliveries="deliveries"
			:shopGroups="shopGroups"
			:distrCenter="distrCenters"
			:deliveryDestinations="deliveryDestinations"
			:productGroups="productGroups"
			@changeType="changeType"
			/>
	</div>
</template>

<script>
import TenderTab from "@/components/sections/Tenders/CreateEditTender/TenderTab.vue";
import TenderForm from "@/components/sections/Tenders/CreateEditTender/TenderForm.vue";

export default {
	name: "CreateEditTender",
	components: {TenderTab, TenderForm},
	props: {
		deliveries: {
			type: Array,
			default: () => []
		},
		shopGroups: {
			type: Array,
			default: () => []
		},
		distrCenters: {
			type: Array,
			default: () => []
		},
		deliveryDestinations: {
			type: Array,
			default: () => []
		},
		productGroups: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			currentTab: 'TN',
		}
	},
	methods: {
		changeType() {
			this.$refs?.tenderTab?.toggleCo()
		}
	}
}
</script>


